export default function formatarHTML(html: string) {
  return html.trim().replace(/\r\n/g, '<br />');
}
